import { backgroundOptions } from '../customizationConstants'

export const getDetailsFromBackground = (background: string) =>
  backgroundOptions.find((option) => option.background === background) ?? backgroundOptions[0]
